// App.js
import './App.css';
import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Sidebar from './components/common/Sidebar';
import Overview from './components/Overview/Overview';
import NetSales from './components/NetSales/NetSales';
import CashFlow from './components/CashFlow/CashFlow';
import MediaSpend from './components/MediaSpend/MediaSpend';
import Stores from './components/Stores/Stores';

import { AuthProvider } from './auth/AuthContext';
import ProtectedRoute from './auth/ProtectedRoute';
import Login from './auth/Login'; 
import { DateRangeProvider } from "./context/DateRangeContext";
import { FilterProvider } from "./context/FilterContext";   // ✅ 新增

function Shell() {
  const loc = useLocation();
  const isLogin = loc.pathname === "/login";

  return (
    <div className="App">
      <div className="main">
        {!isLogin && <Sidebar />}
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<ProtectedRoute><Overview /></ProtectedRoute>} />
          <Route path="/overview" element={<ProtectedRoute><Overview /></ProtectedRoute>} />
          <Route path="/stores" element={<ProtectedRoute><Stores /></ProtectedRoute>} />
          <Route path="/net-sales" element={<ProtectedRoute><NetSales /></ProtectedRoute>} />
          <Route path="/cash-flow" element={<ProtectedRoute><CashFlow /></ProtectedRoute>} />
          <Route path="/media-spend" element={<ProtectedRoute><MediaSpend /></ProtectedRoute>} />
        </Routes>
      </div>
    </div>
  );
}



export default function App() {
  return (
    <AuthProvider>
      <FilterProvider>
        <DateRangeProvider>
          <Shell />
        </DateRangeProvider>
      </FilterProvider>
    </AuthProvider>
  );
}
